// Thin wrappers over http.js's request() for the project ("property")
// endpoints — docs/real-estate/be/10-api-reference.md §A2, §A3, §A7.
// Every function returns the raw `{ data, status }`; callers (store
// actions) read `.data`.
import { request } from './http';

export function getConfig() {
  return request({ path: '/config' });
}

export function listProperties(query) {
  return request({ path: '/properties', params: query });
}

export function createProperty(fields) {
  return request({ method: 'post', path: '/properties', data: fields });
}

export function getProperty(pid) {
  return request({ path: `/properties/${pid}` });
}

// One form section's worth of fields at a time — see FE handoff §5's
// section -> field-list table (Overview/Location/Legal/Sales gallery/Booking).
export function patchProperty(pid, fields) {
  return request({ method: 'patch', path: `/properties/${pid}`, data: fields });
}

export function setProjectStatus(pid, projectStatus) {
  return request({
    method: 'put',
    path: `/properties/${pid}/status`,
    data: { project_status: projectStatus },
  });
}

export function setProjectActive(pid, isActive) {
  return request({
    method: 'put',
    path: `/properties/${pid}/active`,
    data: { is_active: isActive },
  });
}

export function deleteProperty(pid) {
  return request({ method: 'delete', path: `/properties/${pid}` });
}

export function listRegions() {
  return request({ path: '/properties/regions' });
}

export function reindexEmbedding(pid, force = false) {
  return request({
    method: 'post',
    path: `/properties/${pid}/embedding`,
    data: { force },
  });
}

// -- features --
export function listFeatures(pid) {
  return request({ path: `/properties/${pid}/features` });
}
export function createFeature(pid, name) {
  return request({
    method: 'post',
    path: `/properties/${pid}/features`,
    data: { name },
  });
}
export function deleteFeature(pid, featureId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/features/${featureId}`,
  });
}

// -- nearby --
export function listNearby(pid) {
  return request({ path: `/properties/${pid}/nearby` });
}
export function createNearby(pid, fields) {
  return request({
    method: 'post',
    path: `/properties/${pid}/nearby`,
    data: fields,
  });
}
export function deleteNearby(pid, nearbyId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/nearby/${nearbyId}`,
  });
}

// -- gallery --
export function reorderGallery(pid, imageIds) {
  return request({
    method: 'put',
    path: `/properties/${pid}/gallery/order`,
    data: { image_ids: imageIds },
  });
}
export function updateGalleryCaption(pid, imageId, caption) {
  return request({
    method: 'patch',
    path: `/properties/${pid}/gallery/${imageId}`,
    data: { caption },
  });
}
export function deleteGalleryImage(pid, imageId) {
  return request({
    method: 'delete',
    path: `/properties/${pid}/gallery/${imageId}`,
  });
}

// -- assigned agents --
export function setProjectAgents(pid, agentIds) {
  return request({
    method: 'put',
    path: `/properties/${pid}/agents`,
    data: { agent_ids: agentIds },
  });
}
